/**
 * Grow a chat textarea with its content, up to the max-height set in chat.css
 * (after which it scrolls instead).
 *
 * Semantic's `TextArea` does not forward a ref to the underlying DOM node, so
 * callers pass the node they get from the change event.
 */
const autoGrow = (node) => {
  if (!node || typeof node.scrollHeight !== 'number') {
    return;
  }
  node.style.height = 'auto';
  if (node.scrollHeight > 0) {
    node.style.height = `${node.scrollHeight}px`;
  }
};

/** Collapse the field back to its single-row resting height. */
export const resetGrowth = (node) => {
  if (node && node.style) {
    node.style.height = '';
  }
};

export default autoGrow;
